import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-bundle-size',
  standalone: true,
  imports: [],
  templateUrl: './bundle-size.component.html',
  styleUrl: './bundle-size.component.scss',
})
export class BundleSizeComponent {
  @Input() bundleSize: number;
  @Input() bundleSizeText: string;
  @Input() freeShippingText: string;
  @Input() isSelected: boolean = false;
}
